import * as React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill's CSS
import './index.scss'; // Import your custom styles
import { Button, Space } from 'antd';
const { useEffect, useRef } = React;

interface TextEditorProps {
    className?: string;
    placeholder?: string;
    defaultValue?: string;
    value?: string;
    loading?: boolean;
    onSave: () => void;
    onChange: (value: string) => void;
    getEditor: (editor: { getValue: () => string }) => void;
}

const TextEditor: React.FC<TextEditorProps> = ({
    className,
    placeholder,
    defaultValue,
    value,
    loading,
    onChange,
    getEditor,
    onSave
}) => {
    const editorRef = useRef<ReactQuill | null>(null);

    useEffect(() => {
        if (editorRef.current) {
            getEditor({
                getValue: () => editorRef.current?.getEditor().root.innerHTML || '',
            });
        }
    }, [getEditor]);

    const handleChange = (content: string) => {
        onChange(content);
    };

    return (
        <div className={`EditorCont ${className}`}>
            <Space direction='vertical'>
                <ReactQuill
                    ref={editorRef}
                    theme="snow"
                    value={value || defaultValue || ''}
                    onChange={handleChange}
                    placeholder={placeholder}
                    modules={quillConfig.modules}
                />
                <Space direction='horizontal'>
                    <Button type='primary' onClick={onSave} loading={loading}>Save</Button>
                    <Button type='default' onClick={onSave}>Cancel</Button>
                </Space>
            </Space>
        </div>
    );
};

const quillConfig = {
    modules: {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            ['clean'],
        ],
    },
};

TextEditor.defaultProps = {
    className: undefined,
    placeholder: undefined,
    defaultValue: undefined,
    value: undefined,
    onChange: () => { },
    getEditor: () => { },
};

export default TextEditor;
